import { NavigateFunction } from 'react-router-dom';

/**
 * Implements the path.join function from the node path library without the need to import it.
 * @param parts string array of paths to join
 * @param sep the separator to join by or use
 * @returns Successfully join path.
 */
export const pathJoin = (...parts: string[]) => {
    const separator = "/";
    const replace = new RegExp(separator + "{1,}", "g");
    return parts.join(separator).replace(replace, separator);
};

type LinkItem = string | { path: string; params?: any, query?: any };
export const generateLinkString = (link?: LinkItem) => {
    let linkString: string | undefined;
    if (link && typeof link === "string") {
        linkString = link;
    } else if (link && typeof link === "object" && link.path) {
        linkString = link.path;
        if (linkString && link.params && typeof link.params === "object") {
            const keys = Object.keys(link.params);
            keys.forEach((key) => {
                if (linkString) {
                    linkString = linkString.replaceAll(`:${key}`, link.params[key]);
                }
            });
        }
        if (linkString && link.query && typeof link.query === "object") {
            linkString += "?";
            const keys = Object.keys(link.query);
            keys.forEach((key, index) => {
                if (linkString) {
                    if (index > 0) linkString += "&";
                    linkString += `${key}=${link.query[key]}`;
                }
            });
        }
    }
    return linkString;
}
export const goToLink = (navigate:NavigateFunction ,link?: LinkItem, newWindow?: boolean) => {
    let toLink = generateLinkString(link) || "";
    if (!link) {
        return;
    }
    if (newWindow) {
        window.open(toLink, '_blank');
    } else {
        navigate(toLink);
    }
};
export const getFirstStringError = (error: any) => {
    if(typeof error === "string"){
        return error;
    }
    let msg = "Unhandled exception";
    const maniKeys = Object.keys(error);
    if (maniKeys?.length > 0) {
        if (Array.isArray(error[maniKeys[0]])) {
            msg = error[maniKeys[0]][0];
        } else {
            msg = getFirstStringError(error[maniKeys[0]]);
        }
    }
    return msg;
}